



















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useUserStore } from "@/shared/store/user";

@Component({})
export default class SsoLoginError extends Vue {
  userStore = useUserStore();
  portalCustomizationStore = usePortalCustomizationStore();

  onLogOutClicked () {
    this.userStore.logout();
  }

}
